import { ResourceEnum } from "src/constants/constants.ts";

export const defaultSelectSort: Record<string, string> = {
  [ResourceEnum.Country]: "name",
  [ResourceEnum.Currency]: "iso",
  [ResourceEnum.Customer]: "name",
  [ResourceEnum.Supplier]: "name",
  [ResourceEnum.Owner]: "company_name",
  [ResourceEnum.MarketingCompany]: "name",
  [ResourceEnum.BankAccount]: "name",
  [ResourceEnum.AccountingAccount]: "title",
  [ResourceEnum.Attribute]: "title",
  [ResourceEnum.SelectionListAttributeValue]: "title",
  [ResourceEnum.Category]: "title",
  [ResourceEnum.Condition]: "title",
  [ResourceEnum.CustomerGroup]: "title",
  [ResourceEnum.DeliveryMethod]: "title",
  [ResourceEnum.DeliveryService]: "title",
  [ResourceEnum.Discount]: "title",
  [ResourceEnum.DocumentTemplate]: "name",
  [ResourceEnum.Language]: "title",
  [ResourceEnum.Manufacturer]: "title",
  [ResourceEnum.PaymentMethod]: "title",
  [ResourceEnum.PriceList]: "title",
  [ResourceEnum.ProcessingTime]: "title",
  [ResourceEnum.Product]: "title",
  [ResourceEnum.ProductGroup]: "title",
  [ResourceEnum.Role]: "name",
  [ResourceEnum.Unit]: "title",
  [ResourceEnum.User]: "name",
  [ResourceEnum.Variant]: "title",
  [ResourceEnum.VoucherSerie]: "title",
  [ResourceEnum.Warehouse]: "title",
  [ResourceEnum.WarehousePlace]: "title",
};

export const SELECT_DEFAULT_LABEL_PROP = "title";
export const SELECT_DEFAULT_VALUE_PROP = "id";
